/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createTan } from '../../factoriesAny.js';
export var tanDependencies = {
  typedDependencies,
  createTan
};